import { render, staticRenderFns } from "./RadioButtonFacet.vue?vue&type=template&id=cda935b4&scoped=true"
import script from "./RadioButtonFacet.vue?vue&type=script&lang=ts"
export * from "./RadioButtonFacet.vue?vue&type=script&lang=ts"
import style0 from "./RadioButtonFacet.vue?vue&type=style&index=0&id=cda935b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda935b4",
  null
  
)

export default component.exports